// extracted by mini-css-extract-plugin
export default {"block__with__mark":"PackMarkButton_block__with__mark__ZOiZ-","style__span":"PackMarkButton_style__span__aUt7j","style__block":"PackMarkButton_style__block__oIO7Q"};